/*
 * Copyright (c) 2020-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import api from './api';

// Sign-in is Microsoft-only (MSAL), so this service carries only the backend
// session teardown. The email/password `login`, plus `getMe` and `refreshToken`,
// had no callers anywhere and were deleted.
export const authService = {
  async logout(): Promise<void> {
    await api.post('/auth/logout');
  },
};
